var common = require("../../utiles/common");
var i18n = require("../../_i18n");

module.exports = {
  ActionLog: [
    [
      {
        field: "actionDate",
        title: i18n._i18n("操作时间"),
        templet: function (res) {
          return res.actionDate ? common.timestampToTime(res.actionDate) : "";
        },
      },
      {
        field: "individualDisplayName",
        title: i18n._i18n("操作人"),
        templet: function (res) {
          return res.individualDisplayName ? res.individualDisplayName : "";
        },
      },
      { field: "businessType", title: i18n._i18n("操作类型") },
      {
        field: "businessMessage",
        title: i18n._i18n("操作详情"),
      },
      { field: "clientIP", title: i18n._i18n("IP地址") },
    ],
  ],
};



//////////////////
// WEBPACK FOOTER
// ./src/component/actionLog/actionCol.js
// module id = 206
// module chunks = 0